module.exports = __webpack_public_path__ + "assets/img/icon2.86fbbb0f.svg";